export default "__VITE_ASSET__DZgUtLo5__"